export const SUBCOMMITTEE_MEMBER_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: '分科会参加メンバー',
};